/**
 * Directive: switcher
 */
angular.module('acme.common.directive.switcher', [])
.directive('switcher', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/switcher/switcher.tpl.html',
      scope: {
          model: '=',
          switcherLabel: '@',
          switcherTextYes: '@',
          switcherTextNo: '@',
          disabled: '=',
          // Optional; called with the new value only when the user toggles, not on model changes
          onChange: '&'
      },

      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.switcher = {

            state:false,
            switcherTextYes: '',
            switcherTextNo: '',

            init: function() {
                $scope.switcher.switcherTextYes = $scope.switcherTextYes || 'Yes';
                $scope.switcher.switcherTextNo = $scope.switcherTextNo || 'No';
                $scope.switcher.disabled = $scope.disabled || '';

                $scope.$watch('model', this.onModelUpdate);
                $scope.$watch('disabled', this.onDisabledUpdate);
            },
            toggle: function(){
                $scope.model= !this.state;
                $scope.onChange({ value: $scope.model });
            },
            onModelUpdate: function(n,o){
                 $scope.switcher.state = (n);
            },
            onDisabledUpdate: function(n,o){
                 $scope.switcher.disabled = (n);
            }
            
        };
        $scope.switcher.init();

      }]

    };

}]);
